<template>
  <div>
    <card v-loading="loading" :title="$t('externalEmvTaps.pageSingle.title')">
      <span v-if="error">{{ JSON.stringify(error) }}</span>
      <span v-else-if="details">
      <external-emv-tap-details :details="details"/>
    </span>
    </card>
  </div>
</template>
<script>
import ExternalEmvTapDetails from "src/components/ExternalEmvTap/ExternalEmvTapDetails";
import {mapActions, mapState} from "vuex";

export default {
  name: 'ExternalEmvTapPage',
  components: {
    ExternalEmvTapDetails
  },
  methods: {
    ...mapActions(['LoadExternalEmvTap'])
  },
  computed: {
    ...mapState({
      loading: state => state.external_emv_tap.loading,
      details: state => state.external_emv_tap.data,
      error: state => state.external_emv_tap.error,
    }),
  },
  mounted() {
    if (this.details === null || this.details.id != this.$route.params.id) {
      this.LoadExternalEmvTap({id: this.$route.params.id})
    }
  }
};
</script>
<style>
</style>
